/**
 * 脚手架可能面临3种情况，1是有登录页面、2是没有登录页面，但是需要拿到token才能展示，3是既没有登录也不需要token
 */
export const LoginStateEnum = {
  // 有登录页面、并且有token
  LOGIN: 'login',
  // 没有登录页面并且也没有token
  NO_LOGIN_AND_TOKEN: 'no-login-and-token',
  // 没有登录页面、但是有token
  NO_LOGIN_BUT_HAVE_TOKEN: 'no-login-but-have-token'
}
